<span class="loading" *ngIf="loading">
  <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bar></app-side-menu-bar>
<div class="main-content" *ngIf="role === 'QGR'">
  <div class="heading">
    <label class="heading-text">You dont have persmission to view this page</label>
  </div>
</div>
<div class="main-content" *ngIf="role !== 'QGR'">
  <div class="heading">
    <label class="heading-text freeze-upload-msg" *ngIf="freezeUpload">File upload page has been frozen. Kindly contact Global Admin, If you have any queries.</label>
  </div>
  <!-- <label style="color: rgb(240, 69, 69);">This page is under development</label> -->
  <!-- [ngClass]="isAuthorized? '': 'readOnly'" -->
  <div class="filters" [formGroup]="incidentUploadSqlForm">
    <!-- Cluster -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select BU/GBU Sub-Region</mat-label>
        <mat-select [(ngModel)]="clusterdefault" formControlName="uploadclusters" (selectionChange)="loadSite()">
          <mat-option *ngFor="let clus of cluster" [disabled]="disableCluster" [value]="clus">{{clus}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Site -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Site</mat-label>
        <mat-select [(ngModel)]="sitedefault" formControlName="uploadsite" (selectionChange)="loadBigCategory()">
          <mat-option *ngFor="let fact of sites" [disabled]="disableSite" [value]="fact">{{fact}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Big Category -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Business Group</mat-label>
        <mat-select [(ngModel)]="bigcategorydefault" formControlName="bigcategories"
          (selectionChange)="ClearCurrencyOnBigCategorySelect()">
          <mat-option *ngFor="let categ of bigcategoryU" [value]="categ">{{categ}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Currency -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Currency</mat-label>
        
        <mat-select formControlName="currency" (selectionChange)="EnableFileUpload()">
          <mat-option value='default'></mat-option>
          <mat-option *ngFor="let curr of currencies" [value]="curr">{{curr}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="btn-filter">
    <!-- <button type="button" class="btn-qm upload" [disabled]="!disableUpload && !freezeUpload">
      <label for="files"  class="upload-name" >Upload</label>
      <input mat-input id="files" #files #filesUpload style="display: none;" [disabled]="disableUpload"
        (change)="uploadIncidentFile($event.target.files)" type="file" > 
    </button> -->
    <button type="button" class="btn-qm upload"  (click)="openInput()" [disabled]="disableUpload || freezeUpload">Upload</button>
    <input id="fileInput" style="display: none;" type="file" (change)="uploadIncidentFile($event.target.files)" name="file">
    </div>
    <div class="btn-filter">
      <button class="btn-qm" color="primary" (click)="loadDashboard()">{{viewDashboard}}
      </button>
    </div>
    <div class="btn-filter">
    <button *ngIf="deleteincidentdata" class="btn-qm" color="primary" (click)="disableAllUpload()">{{labelDisplay}}
    </button>
    </div>
    <div class="alert alert-success successMsg" *ngIf="showSuccess">
      {{uploadinserted}} <br />
      {{uploadrejected}} <br />
      {{uploadduplicated}} <br />
      {{uploadupdated}}
    </div>
    <div [ngClass]="fileUploadStatusCSS" *ngIf="showFileValidation">
      {{fileValidationMsg}}
    </div>
  </div>
  <!-- END -->
  <div class="progressBarPlaceholder">
    <div class="progressBar" *ngIf="showProgress">
      <mat-progress-bar mode="determinate" value={{progressValue}}></mat-progress-bar>
    </div>
  </div>
  <div>
    <div *ngIf="noRecordsShow" class="records">{{noRecords}}</div>
    <div class="example-container">
      <mat-paginator #paginator 
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons 
                aria-label="Select page of dataSource">
        </mat-paginator>
      <table mat-table [dataSource]="fileDetailsDataSource" *ngIf="!noRecordsShow">
        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
        <!-- SINo Column -->
        <ng-container matColumnDef="SINo">
          <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> SI.No </th>
          <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.fileID}} </td>
        </ng-container>

        <!-- FileName Column -->
        <ng-container matColumnDef="FileName" *ngIf="!deleteincidentdata">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> File Name </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element">
            <span>{{element.fileName}}</span>
          </td>
        </ng-container>

        <!-- FileName Column -->
        <ng-container matColumnDef="FileName" *ngIf="deleteincidentdata">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> File Name </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element">
            <span class="filename" (click)="loadDeleteDataPage(element.fileID)"> {{element.fileName}} </span>
            <!-- <a routerLink = "/deleteincidentdata">{{element.fileName}}</a> -->
          </td>
        </ng-container>

        <!-- local currency Column -->
        <ng-container matColumnDef="UploadedCurrency">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Uploaded Currency </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.localCurrency}} </td>
        </ng-container>

        <!-- UploadedDate Column -->
        <ng-container matColumnDef="UploadedDate">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Uploaded Date </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.uploadedDate | date: 'dd/MM/yyyy HH:mm:ss'}} </td>
        </ng-container>

        <!-- UploadedBy Column -->
        <ng-container matColumnDef="UploadedBy">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Uploaded By </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.uploadedBy}} </td>
        </ng-container>

        <!-- IncidentType Column -->
        <ng-container matColumnDef="IncidentType">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Incident Type </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.incidentType}} </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="Status">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Status</th>
          <td class="leftDataCell" mat-cell *matCellDef="let element" [ngClass]="'mat-status-' + element.uploadedStatus.toLowerCase()"> {{element.uploadedStatus}} </td>
        </ng-container>

        <!-- Dashboard Column -->
        <ng-container matColumnDef="Dashboard">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Dashboard </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element">
            <span *ngIf="element.qaMatrixStatus === 'Done'">
              <span class="filename" (click)="loadDashboard(element.fileID)">View Dashboard</span>
            </span>
            <span *ngIf="element.qaMatrixStatus !== 'Done'">
              <span>--NA--</span>
            </span>
          </td>
        </ng-container>
 
        <ng-container matColumnDef="Error Details">
          <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Error Details </th>
          <td class="rightDataCell" mat-cell *matCellDef="let element">
            <span class="filename" (click)="loadErrorDetails(element.fileID)"> View </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

    </div>
  </div>
</div>
